// Vendors
import React from 'react';
import { FormattedMessage } from 'react-intl';
// Components & UI Structure
import { EmptyStatusComponent } from '@openbank/ziniaweb-ui-components';
// Translations
import {
  PROCESS_ENDED_DESCRIPTION,
  PROCESS_ENDED_TITLE,
} from './translations/process-ended.translations';
// Constants
import { PROCESS_ENDED_PROPS } from './constants/process-ended.constants';
// Styles
import { HeaderLayoutContentFullHeightStyled } from 'styles/app.styled';

const ProcessEndedContainer = (): React.ReactElement => (
  <HeaderLayoutContentFullHeightStyled>
    <EmptyStatusComponent
      {...PROCESS_ENDED_PROPS}
      description={<FormattedMessage id={PROCESS_ENDED_DESCRIPTION} />}
      title={<FormattedMessage id={PROCESS_ENDED_TITLE} />}
    />
  </HeaderLayoutContentFullHeightStyled>
);

export { ProcessEndedContainer };
